/**
 * Constants for Review List Modal
 */

const REVIEW_LIST_MODAL_CONSTANTS = {
  REVIEW_LIST: 'Review List',
  USER_NAME: 'User Name',
  DEPARTMENT: 'Department',
  STATUS: 'Status',
  TOTAL_ITEMS: 'Total Items',
  CLOSE: 'Close',
  SUBTITLE_DEPROVISION:
    'Deprovisioning revokes access immediately and cannot be undone. Review carefully before continuing.',
  SUBTITLE_DOWNGRADE:
    "Downgrading will change the user's license tier. This action reduces costs while preserving access. Review carefully before continuing.",
  SUBTITLE_DEFAULT:
    'Review the affected users and accounts before applying this change.',
  BUTTON_DEPROVISION: 'Deprovision',
  BUTTON_DOWNGRADE: 'Downgrade',
  BUTTON_APPLY: 'Apply',
  CONFIRM_DEPROVISION_SINGLE:
    'Deprovisioning will immediately revoke access for 1 selected account. Users will lose access right away and this cannot be undone.',
  CONFIRM_DEPROVISION_MULTI:
    'Deprovisioning will immediately revoke access for {count} selected accounts. Users will lose access right away and this cannot be undone.',
  CONFIRM_DEPROVISION_ALL:
    'Deprovisioning will immediately revoke access for all listed accounts. Users will lose access right away and this cannot be undone.',
  CONFIRM_DOWNGRADE_SINGLE:
    'Downgrading will move 1 selected account to a lower license tier. Users retain access but with reduced permissions.',
  CONFIRM_DOWNGRADE_MULTI:
    'Downgrading will move {count} selected accounts to a lower license tier. Users retain access but with reduced permissions.',
  CONFIRM_DOWNGRADE_ALL:
    'Downgrading will move all listed accounts to a lower license tier. Users retain access but with reduced permissions.',
  CONFIRM_DEFAULT:
    'You are about to apply this change. Please review your selection before confirming.',
} as const;

export default REVIEW_LIST_MODAL_CONSTANTS;
